<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('basicHr.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="time-box">
                <div class="time-item" :class="{'time-active': activeTime === 0}" @click="changeTimeType(0, $t('dailyActive.time0'))">{{ $t('dailyActive.time0') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 1}" @click="changeTimeType(1, $t('dailyActive.time1'))">{{ $t('dailyActive.time1') }}</div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                <div class="time-date">{{time}}</div>
                <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
                <div class="chart-unit" v-if="mathData.avgData">{{$t('basicHr.unit')}}</div>
            </div>
            <div id="chart-box"></div>
        </div>
        <div class="math-box">
            <van-row>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-num">{{mathData.maxData ? mathData.maxData : '--'}}</div>
                        <div class="math-text">{{$t('basicHr.math0')}}</div>
                    </div>
                </van-col>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-num">{{mathData.minData ? mathData.minData : '--'}}</div>
                        <div class="math-text">{{$t('basicHr.math1')}}</div>
                    </div>
                </van-col>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-num">{{mathData.avgData ? mathData.avgData : '--'}}</div>
                        <div class="math-text">{{$t('basicHr.math2')}}</div>
                    </div>
                </van-col>
            </van-row>
        </div>
        <div class="desc-box">
            <div class="desc-title">{{$t('basicHr.descTitle')}}</div>
            <div class="desc-info last-desc">{{$t('basicHr.desc')}}<br>{{$t('basicHr.desc0')}}
            </div>
        </div>
    </div>
</template>

<script>
    import {getQueryVariable, getSkin} from '@/utils/comment'
    import {
        getToday,
        getNWeekFirstDay,
        getNWeekLastDay,
        getMonthStartDay,
        getMonthEndDay,
        GetDateStr, SwitchTime24,
        changeDate,
        changeMonthDate,
        GetYear
    } from "../../utils/dateUtils";
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'myHr',
        data() {
            return {
                ratio: 1,
                theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
                activeTime: 1,
                timeUnit: '',
                time: '',
                startDate: '',
                endDate: '',
                tNum: 0,
                wNum: 0,
                mNum: 0,
                yNum: 0,
                showTimeBox: false,
                hrInfo: {},
                mathData: {},
                myChart: null,
                showLeftOpacity: 0,
                showRightOpacity: 1
            }
        },
        watch: {
            showTimeBox: {
                handler(newVal, olVal) {
                    if (newVal) {
                        setTimeout(() => {
                            document.addEventListener('click', this.checkClick);
                        }, 0);
                    } else {
                        document.removeEventListener('click', this.checkClick);
                    }
                }
            }
        },
        mounted() {
            this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
            this.timeUnit = this.$t('vo2max.time0');
            this.startDate = getNWeekFirstDay(this.wNum);
            this.endDate = getNWeekLastDay(this.wNum);
            this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            this.getData();
        },
        methods: {
            back() {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            },
            checkClick(event) {
                let dom = this.$refs.showContent; // 这里是你的下拉菜单元素
                if (!dom.contains(event.target)) {
                    // 不在菜单范围，隐藏即可
                    if (this.showTimeBox) {
                        this.showTimeBox = false;
                        document.removeEventListener('click', this.checkClick);
                    }
                }
            },
            checkOpacity() {
                if (this.activeTime == 1 && this.wNum >= 0) {
                    this.showRightOpacity = 1
                } else if (this.activeTime == 2 && this.mNum >= 0) {
                    this.showRightOpacity = 1
                } else {
                    this.showRightOpacity = 0
                }
                if (this.activeTime == 1 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else if (this.activeTime == 2 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else {
                    this.showLeftOpacity = 0
                }
            },
            timeLeft() {
                if (this.activeTime == 1 && this.startDate > '2020-01-01') {
                    this.wNum--;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 2 && this.startDate > '2020-01-01') {
                    this.mNum--;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
                this.checkOpacity();
            },
            timeRight() {
                if (this.activeTime == 1 && this.wNum < 0) {
                    this.wNum++;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 2 && this.mNum < 0) {
                    this.mNum++;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
                this.checkOpacity();
            },
            changeTimeType(num, unit) {
                this.activeTime = num;
                this.timeUnit = unit;
                this.showTimeBox = false;
                if (this.activeTime == 1) {
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                }
                if (this.activeTime == 2) {
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
                this.checkOpacity();
            },
            getData() {
                this.mathData = {}

                let hrInfo;
                this.$api.status.getBasicHr({
                    startDate: this.startDate,
                    endDate: this.endDate
                }).then(res => {
                    if (res.result == 1) {
                        this.mathData.maxData = res.info.maxBasicHr;
                        this.mathData.avgData = res.info.avgBasicHr;
                        this.mathData.minData = res.info.minBasicHr;
                        hrInfo = res.info;
                        this.hrInfo.dateArr = [];
                        this.hrInfo.dataMinArr = [];
                        this.hrInfo.dataMaxArr = [];
                        this.hrInfo.dataBasicArr = [];
                        for (let i = 0; i < hrInfo.dataBasicHr.length; i++) {
                            this.hrInfo.dateArr.push(changeDate(hrInfo.dataBasicHr[i].date));
                            this.hrInfo.dataBasicArr.push(hrInfo.dataBasicHr[i].hrBasic);
                        }
                        this.$nextTick(function () {
                            this.drawChart()
                            this.$forceUpdate()
                        })
                    }
                })
            },
            drawChart() {
                if (!this.myChart) {
                    this.myChart = this.$echarts.init(document.getElementById("chart-box"));
                }
                let barWidth = 10 * this.ratio;
                if (this.activeTime == 1 || this.activeTime == 3) {
                    barWidth = 10 * this.ratio;
                } else {
                    barWidth = 4 * this.ratio;
                }
                if (!this.mathData.avgData) {
                    this.myChart.setOption({
                        title: {
                            text: this.$t('noData'),
                            x: 'center',
                            y: 76 * this.ratio,
                            textStyle: {
                                fontFamily: 'SF',
                                fontSize: 12 * this.ratio,
                                fontWeight: 'normal',
                                color: getSkin('--text-color-2')
                            }
                        },
                        grid: {
                            top: 35 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3')
                            },
                            axisTick: {
                                show: false
                            },
                            data: this.hrInfo.dateArr
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            boundaryGap: [0, '10%'],
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: false
                        },
                        series: [
                            {
                                name: '基础心率',
                                showSymbol: false,
                                itemStyle: {
                                    color: getSkin('--chart-color-7'),
                                },
                                data: [0],
                                type: 'line',
                                lineStyle: {
                                    width: 2,
                                }
                            }
                        ]
                    }, true);
                } else {
                    let _this = this;
                    this.myChart.setOption({
                        grid: {
                            top: 35 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        dataZoom: { // 放大和缩放
                            type: 'inside'
                        },
                        tooltip: {
                            backgroundColor: getSkin('--bg-color-2'),
                            trigger: 'axis',
                            position: (point, params, dom, rect, size) => {
                                let x = point[0]-size.contentSize[0]/2;
                                let cWidth = 375 * _this.ratio;
                                if (x < 0) {
                                    x = 0;
                                } else if ((x + size.contentSize[0]) > cWidth ) {
                                    x =  cWidth - size.contentSize[0];
                                }
                                return [x, '0%'];
                            },
                            formatter: function (params, ticket, callback) {
                                let item = params[0];
                                let value = item.data ? item.data : 0;
                                if (value == 0) return ;
                                let html = '';
                                html += '<div style="font-family:D-D;font-size:13px;margin-bottom: 2px;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;color: ' + getSkin('--text-color-1') + '">' + value + '</span> 次/分</div>'
                                return html
                            }
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3')
                            },
                            axisTick: {
                                show: false
                            },
                            data: this.hrInfo.dateArr
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            boundaryGap: [0, '10%'],
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            }
                        },
                        series: [
                            {
                                name: '基础心率',
                                showSymbol: false,
                                itemStyle: {
                                    color: getSkin('--chart-color-3'),
                                },
                                data: this.hrInfo.dataBasicArr,
                                type: 'line',
                                lineStyle: {
                                    width: 2,
                                },
                                areaStyle: {
                                    color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                        {
                                            offset: 0,
                                            color: getSkin('--bg-color-2'),
                                        },
                                        {
                                            offset: 1,
                                            color: getSkin('--chart-color-4'),
                                        },
                                    ]),
                                }
                            }
                        ]
                    }, true);
                }
            },
        },
        unmounted() {
            document.removeEventListener('click', this.checkClick);
        }
    }
</script>

<style scoped>

    #chart-box {
        height: 198px;
        width: 100%;
    }

    .chart-unit {
        position: absolute;
        font-size: 11px;
        color: var(--text-color-3);
        left: 12px;
        top: 20px;
    }

    .cal-prop-box {
        margin: 0 auto;
        width: 345px;
        background: var(--bg-color-2);
        border-radius: 13px 13px 13px 13px;
    }

    .prop-title {
        font-size: 15px;
        color: var(--text-color-1);
        margin: 0px 15px 12px 16px;
        padding-top: 17px;
    }

    .prop-content {
        font-size: 13px;
        margin: 0 15px 0px 16px;
        color: var(--text-color-2);
        padding-bottom: 16px;
        line-height: 23px;
    }

    .time-box {
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/views/status/17basicHr.vue